import { Input } from "design-react-kit";
import { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import ModalComponent from "../../Components/ModalComponent";
import Select from "../../Components/Select";
import Repo from "../../Utility/Repo";
import { PROVINCE } from "../../Components/listaProvince";
import { NAZIONI } from "../../Components/listaNazioni";
import { TokenContext } from "../../Components/TokenContext";
import { AlertMessage, showError } from "../../Components/AlertMessage";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useHistory } from "react-router-dom";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function NewUser(props) {
  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [validation, setValidation] = useState(false);
  const [validationEmail, setValidationEmail] = useState(true);
  const [validationCF, setValidationCF] = useState(true);
  const [listaProvince] = useState(PROVINCE);
  const [listaNazioni] = useState(NAZIONI);
  const [listaMunicipi, setListaMunicipi] = useState();

  const [apiError, setApiError] = useState({});
  const [nazionePredefinita, setNazionePredefinita] = useState({});

  const [codiceFiscaleAnpr, setCodiceFiscaleAnpr] = useState("");
const [cfError, setCfError] = useState(false);

const [isOpenImportAnpr, setIsOpenImportAnpr] = useState(false);
const [loadingImport, setLoadingImport] = useState(false);
const [anprPreview, setAnprPreview] = useState(null);
const history = useHistory();


  let query = useQuery();

  const [data, setData] = useState({
    firstName: null,
    lastName: null,
    birthDate: null,
    fiscalCode: null,
    email: null,
    phoneNumber: null,
    address: null,
    addressNumber: null,
    cap: null,
    country: null,
    city: null,
    nation: "IT",
    municipioId: null,
  });


const bodyImportAnpr = () => {
  if (anprPreview) {
    return (
      <div>
        <p><strong>Dati trovati:</strong></p>

        <p><b>Nome:</b> {anprPreview.firstName}</p>
        <p><b>Cognome:</b> {anprPreview.lastName}</p>
        <p><b>CF:</b> {anprPreview.fiscalCode}</p>
        <p><b>Data nascita:</b> {anprPreview.birthDate}</p>

        <p className="text-muted mt-3">
          Confermi l'importazione di questo utente?
        </p>
      </div>
    );
  }

  return (
    <Input
      id="cf_anpr"
      label="Codice Fiscale"
      type="text"
      maxLength={16}
      autoComplete="off"
      value={codiceFiscaleAnpr}
      onChange={(e) =>
        setCodiceFiscaleAnpr(e.target.value.toUpperCase())
      }
      {...(cfError && {
        infoText: "Inserire un codice fiscale valido (16 caratteri)",
        className: "text-danger",
      })}
    />
  );
};



  useEffect(() => {
    setNazionePredefinita(
      listaNazioni.find((opzione) => opzione.value === "IT"),
    );
  }, []);

  const handleSelectChange = (selectedOption) => {
    setNazionePredefinita(
      listaNazioni.find((opzione) => opzione.value === selectedOption.value),
    );
    setData({ ...data, nation: selectedOption ? selectedOption.value : "IT" });
  };

  useEffect(() => {
    Repo.getMunicipi(apiToken)
      .then((response) => {
        setListaMunicipi(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const newUserValidation = () => {
    const regexEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    setValidation(true);
    let passedValidation = true;

    if (data.email && !data.email.match(regexEmail)) {
      setValidationEmail(false);
    } else {
      setValidationEmail(true);
    }

    if (data.fiscalCode && data.fiscalCode.length != 16) {
      setValidationCF(false);
    } else {
      setValidationCF(true);
    }

    Object.entries(data).map(([key, value]) => {
      if (
        value === null &&
        key !== "emailPec" &&
        key !== "email" &&
        key !== "phoneNumber" &&
        key !== "municipioId" &&
        key !== "municipio"
      ) {
        passedValidation = false;
      }
    });

    if (passedValidation) {
      toggleModal(!isOpen);
    }
  };

  const handleAlertClose = () => {
    setApiError({ isVisible: false, message: "" });
  };

  const opzioniMunicipi = [
    { value: null, label: "— Nessun municipio —" },
    ...(Array.isArray(listaMunicipi) ? listaMunicipi : []),
  ];

const newUserANPR = async (cf) => {
  try {
    setLoadingImport(true);

    const response = await Repo.getFindUserAnpr(apiToken, cf);

    if (response.status === 200) {
      setIsOpenImportAnpr(false);
      const userId = response.data.id;
      await syncUserFromANPR(cf, userId);

      window.location.href =
        props.subfolder + "/lista_utenti/dati_utente?citizen=" + userId;
    }
  } catch (error) {
    setApiError({ isVisible: true, message: showError(error) });
  } finally {
    setLoadingImport(false);
  }
};


const syncUserFromANPR = async (cf, userId) => {
  try {
    await Repo.getANPRIns(apiToken, cf);

    // Se vuoi ricaricare dati prima del redirect

  } catch (error) {
    console.error("Errore sincronizzazione ANPR:", error);
    alert("Errore durante l'aggiornamento da ANPR");
  }
};

const handleConfirmImportAnpr = async () => {
  const cf = codiceFiscaleAnpr.trim().toUpperCase();

  if (!cf || cf.length !== 16) {
    setCfError(true);
    return;
  }

  setCfError(false);
  setLoadingImport(true);

  try {
    const { data } = await Repo.getFindUserAnpr(apiToken, cf);

    setAnprPreview(data); // 🔥 basta questo
  } catch (error) {
    setApiError({ isVisible: true, message: showError(error) });
  } finally {
    setLoadingImport(false);
  }
};


const handleFinalImport = async () => {
  if (!anprPreview) return;

  try {
    const response = await Repo.getANPRIns(apiToken, codiceFiscaleAnpr);

    console.log("response",response);
    const newUserId = response.data; 

   history.push(
  "/lista_utenti/dati_utente?citizen=" + newUserId
);

  } catch (error) {
    setApiError({ isVisible: true, message: showError(error) });
  }
};




  const insertUserAPI = () => {
    const urlBack = query.get("urlBack");
    //const page = urlBack ? urlBack : props.subfolder + '/dati_utente?citizen=';

    Repo.postInsertUser(apiToken, JSON.stringify(data))
      .then((response) => {
        if (response.status === 200) {
          let userId = response.data.id;
          // Successo, esegui le azioni necessarie
          window.location.href =
            props.subfolder + "/lista_utenti/dati_utente?citizen=" + userId;
        } else {
          // Altri codici di stato di risposta
          // Gestisci di conseguenza
        }
      })
      .catch((error) => {
        toggleModal(!isOpen);

        setApiError({ isVisible: true, message: showError(error) });
      });
  };

  return (
    <>
      <div>
        {apiError.isVisible && (
          <AlertMessage
            isVisible={apiError.isVisible}
            error={apiError.message}
            onClose={handleAlertClose}
          />
        )}

        <h1>Nuovo utente</h1>
        <div className="row">
          <div className="clearfix col-lg-8 py-lg-2">
            <p>Inserisci un nuovo utente</p>
          </div>
<div className="clearfix col-lg-4 py-lg-2">
  <button
    type="button"
    className="btn btn-outline-success float-right p-2"
   onClick={() => {
  setAnprPreview(null);
  setCodiceFiscaleAnpr("");
  setCfError(false);
  setIsOpenImportAnpr(true);
}}
  >
    <svg className="icon icon-success">
      <use href={`${iconSprite}#it-plus-circle`} />
    </svg>
    <span className="align-middle ms-1">Importa ANPR</span>
  </button>
</div>

        </div>

        <div className="col-lg-12 mt-3">
          <div className="row">
            <div className="col-lg-4">
              <Input
                id="first_name"
                required
                label="Nome*"
                type="text"
                name="first_name"
                {...(validation &&
                  !data.firstName && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
                onChange={(e) =>
                  setData({ ...data, firstName: e.target.value })
                }
              />
            </div>
            <div className="col-lg-4">
              <Input
                id="last_name"
                required
                label="Cognome*"
                type="text"
                name="last_name"
                onChange={(e) => setData({ ...data, lastName: e.target.value })}
                {...(validation &&
                  !data.lastName && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
              />
            </div>
            <div className="col-lg-4">
              <Input
                id="fiscal_code"
                required
                label="Codice Fiscale*"
                type="text"
                name="fiscal_code"
                onChange={(e) =>
                  setData({ ...data, fiscalCode: e.target.value })
                }
                {...(validation &&
                  !data.fiscalCode && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
                {...(validation && !validationCF && {
  infoText: "Il codice fiscale è errato!",
  className: "text-danger error_div is-invalid",
})}
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-lg-3">
              <Input
                id="birthdate"
                required
                label="Data di Nascita*"
                type="date"
                name="birthdate"
                placeholder="gg/mm/aaaa"
                onChange={(e) =>
                  setData({ ...data, birthDate: e.target.value })
                }
                {...(validation &&
                  !data.birthDate && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
              />
            </div>
            <div className="col-lg-4">
              <Input
                id="email"
                required
                label="Email"
                type="text"
                name="email"
                onChange={(e) => setData({ ...data, email: e.target.value })}
                // {...(validation &&
                //   !data.email && {
                //     infoText: "Il campo non può essere vuoto!",
                //     className: "text-danger error_div is-invalid",
                //   })}
                {...(validation &&
                  !validationEmail && {
                    infoText: "Il formato dell'email non è corretto!",
                    className: "text-danger error_div is-invalid",
                  })}
              />
            </div>
            <div className="col-lg-3">
              <Input
                id="emailPec"
                label="Pec"
                type="text"
                name="emailPec"
                onChange={(e) => setData({ ...data, emailPec: e.target.value })}
              />
            </div>
            <div className="col-lg-2">
              <Input
                id="phone_number"
                label="Telefono"
                type="text"
                name="phone_number"
                onChange={(e) =>
                  setData({ ...data, phoneNumber: e.target.value })
                }
                // {...(validation &&
                //   !data.phoneNumber && {
                //     infoText: "Il campo non può essere vuoto!",
                //     className: "text-danger error_div is-invalid",
                //   })}
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-lg-6">
              <Input
                id="address"
                required
                label="Indirizzo*"
                type="text"
                name="address"
                onChange={(e) => setData({ ...data, address: e.target.value })}
                {...(validation &&
                  !data.address && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
              />
            </div>
            <div className="col-lg-3">
              <Input
                id="number"
                required
                label="N. Civico*"
                type="text"
                name="number"
                onChange={(e) =>
                  setData({ ...data, addressNumber: e.target.value })
                }
                {...(validation &&
                  !data.addressNumber && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
              />
            </div>
            <div className="col-lg-3">
              <Input
                id="cap"
                required
                label="CAP*"
                type="text"
                name="cap"
                onChange={(e) => setData({ ...data, cap: e.target.value })}
                {...(validation &&
                  !data.cap && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-lg-4">
              <Input
                id="city"
                required
                label="Città*"
                type="text"
                name="city"
                onChange={(e) => setData({ ...data, city: e.target.value })}
                {...(validation &&
                  !data.city && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
              />
            </div>
            <div className="col-lg-4">
              <div className="bootstrap-select-wrapper col-12">
                <Select
                  aria-label="Scegli una provincia*"
                  clearText="Annulla"
                  defaultMenuIsOpen={false}
                  icon={false}
                  id="selectExampleClassic"
                  onChange={(e) => {
                    setData({ ...data, country: e.value });
                  }}
                  options={listaProvince}
                  isSearchable={false}
                  placeholder={"Scegli una provincia*"}
                />
              </div>
              {validation && !data.country ? (
                <small id="errorSelect" className="form-text text-danger">
                  Il campo non può essere vuoto!
                </small>
              ) : (
                <></>
              )}
            </div>
            <div className="col-lg-4">
              <div className="bootstrap-select-wrapper col-12">
                <Select
                  aria-label="Scegli una nazione*"
                  clearText="Annulla"
                  defaultMenuIsOpen={false}
                  icon={false}
                  id="selectExampleClassic"
                  onChange={handleSelectChange}
                  options={listaNazioni}
                  value={nazionePredefinita}
                  isSearchable
                  //  placeholder={"Scegli una nazione*"}
                />
              </div>
              {validation && !data.nation ? (
                <small id="errorSelect" className="form-text text-danger">
                  Il campo non può essere vuoto!
                </small>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="row mt-2">
            <div className="bootstrap-select-wrapper col-12">
              <Select
                aria-label="Scegli un municipio"
                clearText="Annulla"
                defaultMenuIsOpen={false}
                icon={false}
                id="selectMunicipio"
                options={opzioniMunicipi}
                isSearchable
                value={
                  opzioniMunicipi.find((o) => o.value === data?.municipioId) ??
                  null
                }
                onChange={(option) =>
                  setData({
                    ...data,
                    municipioId: option?.value ?? null,
                  })
                }
                placeholder="Scegli un municipio"
              />
            </div>
          </div>
        </div>

        <div className="row my-2">
          <div className="col-lg-12 text-right">
            <button
              type="button"
              className="btn btn-primary"
              data-toggle="tooltip"
              data-placement="top"
              onClick={() => newUserValidation()}
              title="Conferma"
            >
              Conferma
            </button>
          </div>
        </div>

        <ModalComponent
          toggleModal={toggleModal}
          isOpen={isOpen}
          header="Inserimento nuovo utente"
          body="Confermi di voler inserire un nuovo utente?"
          buttonConfirm="Conferma"
          buttonDeny="Annulla"
          function={() => insertUserAPI()}
        ></ModalComponent>

<ModalComponent
  toggleModal={() => {
    setIsOpenImportAnpr(false);
    setAnprPreview(null); // reset
    setCodiceFiscaleAnpr("");
  }}
  isOpen={isOpenImportAnpr}
  header="Importa utente da ANPR"
  body={bodyImportAnpr()}
  buttonConfirm={
    anprPreview
      ? "Conferma importazione"
      : loadingImport
        ? "Ricerca..."
        : "Cerca"
  }
  buttonDeny="Annulla"
  function={
    anprPreview
      ? handleFinalImport
      : handleConfirmImportAnpr
  }
/>


      </div>
    </>
  );
}

export default NewUser;
